import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { VERSION } from '../../../constants/config';

class DefaultFooter extends Component {
   render() {
      // eslint-disable-next-line
      const { children, ...attributes } = this.props;

      return (
         <React.Fragment>
            <span>{`v${VERSION} - © 2019-${new Date().getFullYear()} Nanocosmos GmbH`}</span>
         </React.Fragment>
      );
   }
}

DefaultFooter.propTypes = {
   children: PropTypes.node,
};

DefaultFooter.defaultProps = {};

export default DefaultFooter;
